import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  shared: {
    VERCEL_ENV: z.enum(['production', 'preview', 'staging', 'development']).default('development'),
    NEXT_PUBLIC_BUILD_DATE: z.string().default(new Date().toISOString()),
  },
  server: {
    AUTH_SESSION_NAME: z.string(),
    API_PMS_BASE_URL: z.string(),
    API_CMS_BASE_URL: z.string(),
    ASSETS_CMS_BASE_URL: z.string(),
    API_REPORTING_BASE_URL: z.string(),
    API_WALLET_BASE_URL: z.string(),
    API_PAYMENT_BASE_URL: z.string(),
    API_EXCHANGE_RATE_BASE_URL: z.string(),
    API_CASINO_GAMES_BASE_URL: z.string(),
    NODE_ENVIRONMENT: z.string(),
    INTERCOM_APP_ID_VATAN_TENANT: z.string(),
    INTERCOM_SECRET_VATAN_TENANT: z.string(),
    INTERCOM_APP_ID_HAZARAT_TENANT: z.string(),
    INTERCOM_SECRET_HAZARAT_TENANT: z.string(),
    INTERCOM_APP_ID_SKIBET_TENANT: z.string(),
    INTERCOM_SECRET_SKIBET_TENANT: z.string(),
    INTERCOM_APP_ID_ASABET_TENANT: z.string(),
    INTERCOM_SECRET_ASABET_TENANT: z.string(),
    INTERCOM_APP_ID_GUGUL_TENANT: z.string(),
    INTERCOM_SECRET_GUGUL_TENANT: z.string(),
    INTERCOM_APP_ID_XBET_TENANT: z.string(),
    INTERCOM_SECRET_XBET_TENANT: z.string(),
    INTERCOM_APP_ID_BETNANA_TENANT: z.string(),
    INTERCOM_SECRET_BETNANA_TENANT: z.string(),
    SENTRY_DSN: z.string(),
    MOONPAY_SECRET_KEY: z.string(),
    EDGE_CONFIG: z.string(),
    ANALYZE: z.boolean().default(false),
    SMARTICO_URL: z.string(),
    SMARTICO_ID: z.string(),
    SMARTICO_KEY: z.string(),
  },
  client: {
    NEXT_PUBLIC_INTERCOM_API_BASE: z.string(),
    NEXT_PUBLIC_API_PMS_BASE_URL: z.string(),
    NEXT_PUBLIC_API_CMS_BASE_URL: z.string(),
    NEXT_PUBLIC_API_REPORTING_BASE_URL: z.string(),
    NEXT_PUBLIC_API_WALLET_BASE_URL: z.string(),
    NEXT_PUBLIC_API_PAYMENT_BASE_URL: z.string(),
    NEXT_PUBLIC_API_EXCHANGE_RATE_BASE_URL: z.string(),
    NEXT_PUBLIC_API_CASINO_GAMES_BASE_URL: z.string(),
    NEXT_PUBLIC_BETBY_INTEGRATION_URL: z.string(),
    NEXT_PUBLIC_BETBY_LIBRARY_URL: z.string(),
    NEXT_PUBLIC_BETBY_BRAND_ID: z.string(),
    NEXT_PUBLIC_SENTRY_DSN: z.string(),
    NEXT_PUBLIC_APP_STORE_STORAGE_KEY: z.string(),
    NEXT_PUBLIC_MOONPAY_KEY: z.string(),
  },
  runtimeEnv: {
    NODE_ENVIRONMENT: process.env.NODE_ENV,
    AUTH_SESSION_NAME: process.env.AUTH_SESSION_NAME,
    API_PMS_BASE_URL: process.env.API_PMS_BASE_URL,
    API_CMS_BASE_URL: process.env.API_CMS_BASE_URL,
    ASSETS_CMS_BASE_URL: process.env.ASSETS_CMS_BASE_URL,
    API_REPORTING_BASE_URL: process.env.API_REPORTING_BASE_URL,
    API_WALLET_BASE_URL: process.env.API_WALLET_BASE_URL,
    API_PAYMENT_BASE_URL: process.env.API_PAYMENT_BASE_URL,
    API_EXCHANGE_RATE_BASE_URL: process.env.API_EXCHANGE_RATE_BASE_URL,
    API_CASINO_GAMES_BASE_URL: process.env.API_CASINO_GAMES_BASE_URL,
    SENTRY_DSN: process.env.SENTRY_DSN,
    VERCEL_ENV: process.env.VERCEL_ENV,
    NEXT_PUBLIC_INTERCOM_API_BASE: process.env.NEXT_PUBLIC_INTERCOM_API_BASE,
    INTERCOM_APP_ID_VATAN_TENANT: process.env.INTERCOM_APP_ID_VATAN_TENANT,
    INTERCOM_SECRET_VATAN_TENANT: process.env.INTERCOM_SECRET_VATAN_TENANT,
    INTERCOM_APP_ID_HAZARAT_TENANT: process.env.INTERCOM_APP_ID_HAZARAT_TENANT,
    INTERCOM_SECRET_HAZARAT_TENANT: process.env.INTERCOM_SECRET_HAZARAT_TENANT,
    INTERCOM_APP_ID_SKIBET_TENANT: process.env.INTERCOM_APP_ID_SKIBET_TENANT,
    INTERCOM_SECRET_SKIBET_TENANT: process.env.INTERCOM_SECRET_SKIBET_TENANT,
    INTERCOM_APP_ID_ASABET_TENANT: process.env.INTERCOM_APP_ID_ASABET_TENANT,
    INTERCOM_SECRET_ASABET_TENANT: process.env.INTERCOM_SECRET_ASABET_TENANT,
    INTERCOM_APP_ID_GUGUL_TENANT: process.env.INTERCOM_APP_ID_GUGUL_TENANT,
    INTERCOM_SECRET_GUGUL_TENANT: process.env.INTERCOM_SECRET_GUGUL_TENANT,
    INTERCOM_APP_ID_XBET_TENANT: process.env.INTERCOM_APP_ID_XBET_TENANT,
    INTERCOM_SECRET_XBET_TENANT: process.env.INTERCOM_SECRET_XBET_TENANT,
    INTERCOM_APP_ID_BETNANA_TENANT: process.env.INTERCOM_APP_ID_BETNANA_TENANT,
    INTERCOM_SECRET_BETNANA_TENANT: process.env.INTERCOM_SECRET_BETNANA_TENANT,
    NEXT_PUBLIC_API_PMS_BASE_URL: process.env.NEXT_PUBLIC_API_PMS_BASE_URL,
    NEXT_PUBLIC_API_CMS_BASE_URL: process.env.NEXT_PUBLIC_API_CMS_BASE_URL,
    NEXT_PUBLIC_API_REPORTING_BASE_URL: process.env.NEXT_PUBLIC_API_REPORTING_BASE_URL,
    NEXT_PUBLIC_API_WALLET_BASE_URL: process.env.NEXT_PUBLIC_API_WALLET_BASE_URL,
    NEXT_PUBLIC_API_PAYMENT_BASE_URL: process.env.NEXT_PUBLIC_API_PAYMENT_BASE_URL,
    NEXT_PUBLIC_API_EXCHANGE_RATE_BASE_URL: process.env.NEXT_PUBLIC_API_EXCHANGE_RATE_BASE_URL,
    NEXT_PUBLIC_API_CASINO_GAMES_BASE_URL: process.env.NEXT_PUBLIC_API_CASINO_GAMES_BASE_URL,
    NEXT_PUBLIC_BETBY_INTEGRATION_URL: process.env.NEXT_PUBLIC_BETBY_INTEGRATION_URL,
    NEXT_PUBLIC_BETBY_LIBRARY_URL: process.env.NEXT_PUBLIC_BETBY_LIBRARY_URL,
    NEXT_PUBLIC_BETBY_BRAND_ID: process.env.NEXT_PUBLIC_BETBY_BRAND_ID,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_APP_STORE_STORAGE_KEY: process.env.NEXT_PUBLIC_APP_STORE_STORAGE_KEY,
    NEXT_PUBLIC_MOONPAY_KEY: process.env.NEXT_PUBLIC_MOONPAY_KEY,
    MOONPAY_SECRET_KEY: process.env.MOONPAY_SECRET_KEY,
    NEXT_PUBLIC_BUILD_DATE: process.env.NEXT_PUBLIC_BUILD_DATE,
    EDGE_CONFIG: process.env.EDGE_CONFIG,
    ANALYZE: process.env.ANALYZE,
    SMARTICO_URL: process.env.SMARTICO_URL,
    SMARTICO_ID: process.env.SMARTICO_ID,
    SMARTICO_KEY: process.env.SMARTICO_KEY,
  },
});
